require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-j-3-a-bs-xstream.json") })
        }
      }, "path---package-j-3-a-bs-xstream");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-j-3-a-bs-xstream!./.cache/json/package-j-3-a-bs-xstream.json
// module id = 870
// module chunks = 231608221292675